import { Resource, ResourceAttributes } from '@opentelemetry/resources';

let otelResource: Resource | undefined;

export const getResource = (): Resource => {
  if (!otelResource) {
    throw new Error('[OTel] Resource not initialized — ensure InitOtel() is called before any telemetry component mounts');
  }
  return otelResource;
};

export function initResource(params: ResourceAttributes) {
  otelResource = Resource.default().merge(new Resource(params));
}
